export const getStore = state => state.analysis || {};

export const getAnalysis = state => getStore(state).analysis || {};
export const getNewDocument = state => getStore(state).newDocument;
export const isFetching = state => getStore(state).fetching;
export const isFetched = state => getStore(state).fetched;
export const hasFailed = state => getStore(state).failed;
